// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/ConfirmDeleteEventModal/ConfirmDeleteEventModal.css
// module id = 1306
// module chunks = 0